module.exports = __webpack_public_path__ + "static/media/experiencesampling.63b4cc98.jpeg";